import { useState } from "react";
import "./MobileImagecarousel.css";
import { images } from "../../importImages";
import galleryData from "../../galleryItems.json";

export default function MobileImagecarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + galleryData.length) % galleryData.length
    );
  };

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) handleNext();
    if (isRightSwipe) handlePrevious();
  };

  const currentItem = galleryData[currentIndex];

  return (
    <div className="mobile-carousel">
      <img
        className="mobile-image-resize"
        key={currentItem}
        src={images[currentItem.image]}
        alt={currentItem}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      />
      <p className="mobile-p-carousel">{currentItem.text}</p>

      <div className="mobile-indicator">
        {galleryData.map((_, index) => (
          <div
            key={index}
            className={`mobile-dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>
    </div>
  );
}
